<template>
  <v-layout>
    <v-flex xs12>
      <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
      <apexchart
        ref="tagreport"
        type="bar"
        :height="chartHeight"
        width="100%"
        :options="options"
        :series="series"
      ></apexchart>
    </v-flex>
  </v-layout>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from './DashboardGraphLoading'

export default {
  props: ['selectedDate', 'data', 'loading'],
  data() {
    return {}
  },
  components: {
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  mounted() {},
  computed: {
    options() {
      return {
        chart: {
          id: 'vuechart-example'
        },
        colors: ['#52e3f9'],
        dataLabels: {
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            colors: ['#000']
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: this.data.map((v) => v.usertags)
        },
        yaxis: {
          opposite: false,
          labels: {
            maxWidth: 'auto'
          }
        }
      }
    },
    series() {
      return [
        {
          name: 'Total',
          data: this.data.map((v) => v.count)
        }
      ]
    },
    usertags() {
      return this.data.map((v) => v.usertags)
    },
    count() {
      return this.data.map((v) => v.count)
    },
    chartHeight() {
      const countTag = Object.keys(this.data).length
      let height = 'auto'
      if (countTag > 500) {
        height = '6500'
      } else if (countTag > 200) {
        height = '3500'
      } else if (countTag > 100) {
        height = '3000'
      } else if (countTag > 35) {
        height = '2000'
      }
      return height
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/TagReportGraph.vue